var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscordCircle = function SvgDiscordCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 38 38"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "#5865F2",
    rx: 19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.378 10q-.35.619-.636 1.274a18.7 18.7 0 0 0-5.495 0A13 13 0 0 0 15.611 10a20.2 20.2 0 0 0-4.954 1.51C7.527 16.1 6.679 20.57 7.1 24.98a20 20 0 0 0 6.074 3.016c.492-.653.928-1.35 1.301-2.074a13 13 0 0 1-2.048-.966c.172-.123.34-.251.502-.374a14.4 14.4 0 0 0 12.143 0q.244.201.503.374-.984.575-2.053.97a14.4 14.4 0 0 0 1.301 2.075 20 20 0 0 0 6.074-3.012c.498-5.114-.852-9.547-3.566-13.473a19.9 19.9 0 0 0-4.949-1.506zm-7.366 12.265c-1.182 0-2.163-1.06-2.163-2.372s.943-2.378 2.159-2.378 2.182 1.07 2.163 2.378c-.02 1.307-.952 2.372-2.159 2.372m7.974 0c-1.187 0-2.158-1.06-2.158-2.372s.943-2.378 2.158-2.378c1.216 0 2.178 1.07 2.159 2.378-.02 1.307-.952 2.372-2.159 2.372"
  })));
};
export default SvgDiscordCircle;